import React, { useEffect, useState } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import img from "../Assets/1721270706-bpfull 8.png";
import messageicon from "../Assets/messageicon.svg";
import cam from "../Assets/camera-svgrepo-com (2) 2.png";
import { useNavigate, useParams } from 'react-router-dom';
import { apiGet, apiPost, apiPut } from '../ApiUrls';
import ContentLoader from 'react-content-loader';
import heart from "../Assets/hear.png";
import redHeart from "../Assets/redHeart.png";
import { toast } from 'react-toastify';
import UserChatModal from '../Components/UserChatModal';
import SEOData from '../Components/SEOData';

function ModelDetailPage() {
    const { id } = useParams()
    const navigate = useNavigate()
    const [HostessDetail, setHostessDetail] = useState({});
    const [IsLoading, setIsLoading] = useState(false);
    const [IsLiked, setIsLiked] = useState(false);
    const [Issubcribed, setsubcribed] = useState(false);
    const GetAHostess = async () => {
        try {
            setIsLoading(true)
            const response = await apiGet(`api/admin/GetAHostess/${id}`);
            setHostessDetail(response?.data);
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error);
        }
    }

    useEffect(() => {
        if (id) {
            GetAHostess()
        }
        else {
            navigate(-1);
        }
    }, [id]);

    const [IsLogin, setsetIsLogin] = useState(false);
    const [UserId, setUserId] = useState('');

    useEffect(() => {
        const dataToken = localStorage.getItem("userToken");
        const userid = localStorage.getItem("userid");
        if (dataToken) {
            setUserId(userid)
            setsetIsLogin(true);
        } else {
            setsetIsLogin(false);
        }
    }, []);

    const [IsUser, setIsUser] = useState(false);
    const [IsHostess, setIsHostess] = useState(false);

    useEffect(() => {
        const userType = JSON.parse(localStorage.getItem("userType"));

        if (userType === "User") {
            setIsUser(true);
        }
        if (userType === "Hostess") {
            setIsHostess(true);
        }
    }, []);

    const [UserProfile, setUserProfile] = useState({});

    const GetUserProfile = async () => {
        try {
            const response = await apiGet(`api/user/GetUserProfile`);
            setUserProfile(response?.data);
            setIsLiked(response?.data?.LikedHostess?.includes(id))
            setsubcribed(response?.data?.AllsubscribedHostess?.includes(id))
        } catch (error) {
            console.log(error);
        }
    };

    const AddTolastVisit = async () => {
        try {
            const response = await apiGet(`api/user/AddTolastVisit/${id}`);
            console.log('called ')
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (IsLogin) {
            if (IsUser) {
                GetUserProfile();
            }
        }
    }, [IsLogin]);

    useEffect(() => {
        if (IsLogin && IsUser && HostessDetail?.LastVisit) {
            if (!HostessDetail.LastVisit.includes(UserId)) {
                AddTolastVisit();
            }
        }
    }, [IsLogin, IsUser, HostessDetail]); 
    

    const [UserChatmodel, setUserChatmodel] = useState(false);
    const [SelectedHost, setSelectedHost] = useState(null);

    const OpenUserChatModel = (Hostid) => {
        const {
            _id: id,
            ModelType: model,
            UserName: name,
            Email: email,
            Gallary: [profilePicture],
        } = Hostid;

        const formattedData = {
            id,
            model,
            name,
            email,
            profilePicture,
        };
        setSelectedHost(formattedData);
        setUserChatmodel(true);
    };

    const CloseUserChatModel = () => {
        setSelectedHost(null)
        setUserChatmodel(false)
    }



    const LikeHostess = async (id) => {
        try {
            if (!IsLogin) {
                navigate('/login')
                return toast.success("Please Login as User");
            }
            if (!IsUser) {
                return toast.success("Please Login as User");
            }
            const response = await apiPost(`api/user/LikeHostess/${id}`);
            GetUserProfile();
            toast.success(response?.message);
        } catch (error) {
            toast.success(error?.response?.message);
            console.log(error);
        }
    };

    const SubcribeHostess = async () => {
        try {
            if (!IsLogin) {
                return toast.success("Please Login as User");
            }
            if (!IsUser) {
                return toast.success("Please Login as User");
            }
            const data = {
                Hostess: id,
                Amount: HostessDetail?.SubcriptionPrice,
                TaxAndFess: "",
                CouponCode: "",
                Totaldiscount: ""
            }
            const response = await apiPost(`api/user/CreateSubcription`, data);
            if (response?.data) {
                UpdateSubcription(response?.data?._id)
            }
            toast.success(response?.message)
        } catch (error) {
            toast.success(error?.response?.message);
            console.log(error);
        }
    }


    const UpdateSubcription = async (id) => {
        try {

            const data = {
                PaymentId: "wekbwclkl",
                PaymentStatus: true,
                Subcriptionstatus: "booked"
            }
            const response = await apiPut(`api/user/UpdateSubcription/${id}`, data);
            GetUserProfile();
            console.log(response)
            return toast.success(response?.message || 'subscribed Hosstess');
        } catch (error) {
            toast.success(error?.response?.message);
            console.log(error);
        }
    }


    return (
        <>
            <Navbar />
            <SEOData PageName={'ModelDetail'} />
            {
                IsLoading ?
                    <div className='ml-pl'>

                        <ContentLoader viewBox="0 0 800 400" height='100%' width='100%'>
                            <circle cx="472" cy="159" r="7" />
                            <rect x="487" y="154" rx="5" ry="5" width="220" height="10" />
                            <circle cx="472" cy="190" r="7" />
                            <rect x="487" y="184" rx="5" ry="5" width="220" height="10" />
                            <circle cx="472" cy="219" r="7" />
                            <rect x="487" y="214" rx="5" ry="5" width="220" height="10" />
                            <circle cx="472" cy="249" r="7" />
                            <rect x="487" y="244" rx="5" ry="5" width="220" height="10" />
                            <rect x="64" y="18" rx="0" ry="0" width="346" height="300" />
                            <rect x="229" y="300" rx="0" ry="0" width="0" height="0" />
                            <rect x="111" y="340" rx="0" ry="0" width="0" height="0" />
                            <rect x="121" y="342" rx="0" ry="0" width="0" height="0" />
                            <rect x="10" y="20" rx="0" ry="0" width="40" height="44" />
                            <rect x="10" y="80" rx="0" ry="0" width="40" height="44" />
                            <rect x="10" y="140" rx="0" ry="0" width="40" height="44" />
                            <rect x="194" y="329" rx="0" ry="0" width="0" height="0" />
                            <rect x="192" y="323" rx="0" ry="0" width="0" height="0" />
                            <rect x="185" y="323" rx="0" ry="0" width="0" height="0" />
                            <rect x="10" y="200" rx="0" ry="0" width="40" height="44" />
                            <rect x="470" y="18" rx="0" ry="0" width="300" height="25" />
                            <rect x="470" y="58" rx="0" ry="0" width="300" height="6" />
                            <rect x="470" y="68" rx="0" ry="0" width="300" height="6" />
                            <rect x="470" y="78" rx="0" ry="0" width="300" height="6" />
                            <rect x="798" y="135" rx="0" ry="0" width="0" height="0" />
                            <rect x="731" y="132" rx="0" ry="0" width="0" height="0" />
                            <rect x="470" y="99" rx="0" ry="0" width="70" height="30" />
                            <rect x="560" y="99" rx="0" ry="0" width="70" height="30" />
                        </ContentLoader>
                    </div>

                    :
                    <div className='ml-pl'>

                        <div className="main-detail">
                            <div className="main-detail-left">
                                <div >
                                    <h3>{HostessDetail?.UserName || "Glen Bell"}</h3>
                                    <br />
                                </div>
                                <img
                                    src={HostessDetail?.ProfileImage ? HostessDetail?.ProfileImage : img}
                                    alt="Model"
                                    className="model-image"
                                />
                                <img

                                    onClick={() => { LikeHostess(id) }}
                                    className="Edit heart-icon"
                                    src={IsLiked ? redHeart : heart}
                                    alt="heart"
                                />
                                {
                                    Issubcribed ?
                                        <div onClick={() => (OpenUserChatModel(HostessDetail))} className="main-detail-left-Text">
                                            <img
                                                src={messageicon}
                                                alt="message"
                                                className='Messageimage'
                                            />
                                            Start Chat With {HostessDetail?.UserName}
                                        </div>
                                        :
                                        <div className="main-detail-left-Text" onClick={SubcribeHostess}>
                                            <img
                                                src={messageicon}
                                                alt="message"
                                                className='Messageimage'
                                            />
                                            Please Subscribe {HostessDetail?.SubcriptionPrice} to Chat with {HostessDetail?.UserName}
                                        </div>
                                }
                            </div>

                            <div className="main-detail-right">

                                <div className="ProfileStatus">
                                    {/* <h3>Model Profile </h3>
                                <br />
                                <div style={{ margin: 10 }}>
                                    <h3>{HostessDetail?.UserName || "Glen Bell"}</h3>
                                </div> */}
                                    <br />
                                    <div className="username-img">
                                        <div className="username-name">
                                            <p>{HostessDetail?.MakeAvailable ? "Available" : "UnAvailable"}</p>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="PhotoGallery">
                                        <h2>About Me</h2>

                                        <p>
                                            {HostessDetail?.AboutMe}
                                        </p>
                                    </div>
                                    <br />
                                    <div className="PhotoGallery">
                                        <h2>Photo Gallery</h2>

                                        <div className="PhotoGallery-div">
                                            {HostessDetail?.Gallary?.map((image, index) => (
                                                <img className="GallaryImage" key={index} src={image} alt={`Gallery Image ${index + 1}`} />
                                            ))}
                                        </div>
                                    </div>
                                    <br />
                                    <div className="PhotoGallery">
                                        <h2>Available for</h2>

                                        <div className="ModelPhoto-div">
                                            {HostessDetail?.AvailableFor?.map((item, index) => (
                                                <div className="ModelPhoto" key={index}>
                                                    <img src={cam} />
                                                    <h3>{item}</h3>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <br />
                                    {/* <div className="PhotoGallery">
                                        <h2>Personality & Hobibes</h2>
                                        <div className="ModelPhoto-div">
                                            {HostessDetail?.PersonalityorHobbies?.map((item, index) => (
                                                <div className="ModelPhoto" key={index}>
                                                    <h3>{item}</h3>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <br /> */}

                                    <div className="PhotoGallery">
                                        <h2>Basic Details</h2>
                                        <br />
                                        <div className="basicdetails">
                                            <div className="loc-icon">
                                                <i class="bi bi-geo-alt"></i>
                                            </div>
                                            <div>
                                                <h6>{HostessDetail?.State}</h6>
                                                <h5> {HostessDetail?.City}</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="PhotoGallery">
                                        <h2>Contact Details</h2>
                                        <br />
                                        <div className="basicdetails">
                                            <div className="loc-icon">
                                                <i class="bi bi-telephone"></i>
                                            </div>
                                            <div>
                                                <h3>+91-{HostessDetail?.Number}</h3>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="basicdetails">
                                            <div className="loc-icon">
                                                <i class="bi bi-envelope"></i>
                                            </div>
                                            <div>
                                                <h3>{HostessDetail?.Email}</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="PhotoGallery">
                                        <h2>Personal Details</h2>
                                        <br />
                                        <div className="basicdetails">
                                            <div className="loc-icon">
                                                <i class="bi bi-person"></i>
                                            </div>
                                            <div>
                                                <h6>Name</h6>
                                                <h5>{HostessDetail?.UserName}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            }
            <UserChatModal isOpen={UserChatmodel} toggleModal={CloseUserChatModel} Host={SelectedHost} />

            <Footer />
        </>
    );
}

export default ModelDetailPage;
